import { Option, Result } from "@cartographerio/fp";
import { isPoint, safePointToNgr, } from "@cartographerio/geometry";
import { hasKey, hasOptionalKey, isNullable, isObject, isString, } from "@cartographerio/guard";
import { isTimestamp } from "@cartographerio/types";
import { midpoint } from "@turf/midpoint";
function isPartialLocation(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "upstream", isNullable(isPoint)) &&
        hasOptionalKey(data, "downstream", isNullable(isPoint)) &&
        hasOptionalKey(data, "name", isNullable(isString)));
}
export function isPartialData(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "recorded", isNullable(isTimestamp)) &&
        hasOptionalKey(data, "badgedGroupName", isNullable(isString)) &&
        hasKey(data, "location", isPartialLocation));
}
function locationMidpoint(data) {
    return Option.wrap(data.upstream).fold(() => Option.wrap(data.downstream).fold(() => Option.none(), dn => Option.some(dn)), up => Option.wrap(data.downstream).fold(() => Option.some(up), dn => Option.some(midpoint(up.coordinates, dn.coordinates).geometry)));
}
const g = Result.guard(isPartialData, "PartialThames21BadgedGroupEvent");
export function dataDescription(data) {
    return g(data).map(data => [
        Option.wrap(data.badgedGroupName).getOrElse(() => "Unknown group"),
        Option.wrap(data.location.name).getOrElse(() => "Unknown site"),
        locationMidpoint(data.location).fold(() => "Unknown NGR", safePointToNgr),
    ].join(", "));
}
export function dataGeometry(data) {
    return g(data).map(data => locationMidpoint(data.location).getOrNull());
}
export function dataTimestamp(data) {
    return g(data).map(data => data.recorded ?? null);
}
export function copyData(data) {
    return g(data).map(data => ({ ...data, recorded: null }));
}
//# sourceMappingURL=parts.js.map